import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  value: "default",
  disabled: ""
}
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    class: "sortOptionsWrapper",
    id: "sortButtonControl",
    role: "region",
    "aria-labelledby": "sortButtonID",
    ref: "sortByPanel",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
    onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSelectChange(_ctx.selected)))
  }, [
    _createElementVNode("option", _hoisted_1, _toDisplayString(_ctx.$t("Web.Containers.SortOrder.Title")), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
      return (_openBlock(), _createElementBlock("option", {
        key: option.key,
        value: {
        key: option.key,
        displayName: option.displayName,
        type: option.type,
        isDescending: option.isDescending
      }
      }, _toDisplayString(_ctx.$t("Web.Containers.SortOrder." + option?.displayName.replace(" ", ""))), 9, _hoisted_2))
    }), 128))
  ], 544)), [
    [_vModelSelect, _ctx.selected]
  ])
}